import * as React from 'react';
import {lazyInject, TYPES} from '../../../../../utils/inversify-config';
import MiranaServiceClient from '../../../../../middleware/mirana-client';
import {Field, reduxForm} from 'redux-form';
import {RouteComponentProps} from 'react-router-dom';
import {Store} from 'react-redux';
import MiranaState from '../../../../../reduxstore/mirana-state';
import 'filepond/dist/filepond.min.css';
import renderDatePickerField from '../../../../../theme/components/form/DatePicker';
import * as moment from 'moment';
import CalendarBlankIcon from 'mdi-react/CalendarBlankIcon';
import validate from '../../../stock/producto/validate';

interface IState {
    error?: string;

}

interface IProps {
    handleFechaChange: (fecha: any) => void;
}

class CelularesZonasCargaForm extends React.Component<RouteComponentProps<any> & IProps, IState> {

    @lazyInject(TYPES.MIRANA_SERVICE)
    public apiClient: MiranaServiceClient;

    @lazyInject(TYPES.REDUX_STORE)
    public reduxStore: Store<MiranaState>;

    constructor(props) {
        super(props);
        this.state = {};
    }

    public render() {
        return (
            <div className='form'>
                <label className='form__form-group-label'>Fecha</label>
                <div className='form__form-group-field'>
                    <Field
                        name='fecha'
                        component={renderDatePickerField}
                        filterDate={(date) => {
                            return moment() > date;
                        }}
                        defaultDate={moment()}
                        onChange={this.props.handleFechaChange}
                        placeholder='dd/mm/yyyy'
                    />
                    <div className='form__form-group-icon'>
                        <CalendarBlankIcon/>
                    </div>
                </div>
            </div>

        );
    }
}

export default reduxForm({
    form: 'celulares_zonas_carga_form', // a unique identifier for this form
    validate,
})(CelularesZonasCargaForm);


// WEBPACK FOOTER //
// ./src/components/pages/celulares/zonas/carga/celulares-zonas-carga-form.tsx